import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleSelectedOptions,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fclear--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fclear--{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fclear--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fclear--{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Iblack--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Iblack--{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Itortoise--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Itortoise--{nnn}.png',
    },
    Fglacierblue: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fglacialblue--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fglacialblue--{nnn}.png',
    },
    Fblack: {
      pathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fpblack--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/c4pf_Fpblack--{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bblack--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bblack--{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bblue--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bblue--{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Brosegold--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Brosegold--{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bsilver--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bsilver--{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgold--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgold--{nnn}.png',
    },
    Bgreen: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgreen--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgreen--{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bred--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bred--{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bwhite--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bwhite--{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgunmetal--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/icons/cproi_Bgunmetal--{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_blue_{nnn}.png',
    },
    brown: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_brown_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_green_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_pink_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_pink_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_silverblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Classics/c3le/c3le_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Classics/c3le/c3le_clear_{nnn}.png',
    },
    rose: {
      pathTemplate: 'gs://sg360/260706/classics4pro/lenses/cprole_rose_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/lenses/cprole_rose_{nnn}.png',
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260706/classics4pro/lenses/cprole_hvblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260706/classics4pro/lenses/cprole_hvblue_{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260706/classics4pro/lenses/cprole_hvblue_{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_8P_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250430/classics4/c4_shadow_{nnn}.png',
    },
  },
}

// Add IRIS to options for this everyday product.
function resolveOptions(customisedProduct) {
  const options = resolveLifestyleSelectedOptions(customisedProduct)

  return {
    ...options,
    iris: options.lens,
  }
}

export default {
  layers: [background, frame, icons, lenses, engraving, reflection, iris],
  resolveOptions,
  resolveOptionsFromSKU,
}
